const cyberpunk = {
    50: '#f9e7fc',
    100: '#efc3f8',
    200: '#e49cf3',
    300: '#d974ee',
    400: '#d156eb',
    500: '#c938e7',
    600: '#c332e4',
    700: '#bc2be0',
    800: '#b524dd',
    900: '#a917d7',
    A100: '#ffffff',
    A200: '#f4d5ff',
    A400: '#e7a2ff',
    A700: '#e089ff',
    'contrastDefaultColor': 'light',
};

export default cyberpunk;
